import React from 'react';
import { channelPerf } from '../../mock';

export default function CampaignPerf() {
  return (
    <section className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-10 lg:mb-14 items-end">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-white/50 mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Campaign Performance</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              Q3 2026 ABM · <span className="font-serif italic font-normal">Acme Corp.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 grid grid-cols-3 gap-4">
            <div><div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">Total Leads</div><div className="text-3xl font-medium tabular">564</div></div>
            <div><div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">MQL + Hot</div><div className="text-3xl font-medium tabular">15</div></div>
            <div><div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">Ad Spend</div><div className="text-3xl font-medium tabular text-[#4ECDC4]">$38.5k</div></div>
          </div>
        </div>

        <div className="bg-[#12234C] border border-white/10 rounded-2xl overflow-hidden reveal">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-4 bg-white/[0.06] border-b border-white/10 text-[10px] font-mono uppercase tracking-widest text-white/50">
            <div className="col-span-2">Channel</div>
            <div className="col-span-2 text-right">Impressions</div>
            <div className="col-span-1 text-right">Clicks</div>
            <div className="col-span-2 text-right">Leads</div>
            <div className="col-span-2 text-right">Spend</div>
            <div className="col-span-1 text-right">CPL</div>
            <div className="col-span-2 text-right">Conv rate</div>
          </div>
          {channelPerf.map((c) => {
            const maxLeads = Math.max(...channelPerf.map(x => x.leads));
            const pct = (c.leads / maxLeads) * 100;
            return (
              <div key={c.channel} className="px-6 py-5 border-b border-white/5 hover:bg-white/[0.06]/[0.04] transition">
                <div className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 items-center">
                  <div className="col-span-2"><span className="text-sm font-medium">{c.channel}</span></div>
                  <div className="col-span-2 text-right font-mono text-sm text-white/70">{c.impressions}</div>
                  <div className="col-span-1 text-right font-mono text-sm text-white/70">{c.clicks}</div>
                  <div className="col-span-2 flex items-center gap-2 justify-end">
                    <div className="h-1.5 bg-[#4ECDC4]/20 rounded-full flex-1 overflow-hidden">
                      <div className="h-full bg-[#4ECDC4]" style={{ width: `${pct}%` }} />
                    </div>
                    <span className="font-mono text-sm font-medium tabular w-10 text-right">{c.leads}</span>
                  </div>
                  <div className="col-span-2 text-right font-mono text-sm text-white/70">{c.spend}</div>
                  <div className="col-span-1 text-right font-mono text-sm text-white/70">{c.cpl}</div>
                  <div className="col-span-2 text-right font-mono text-sm font-semibold text-[#F1EDE4]">{c.conv}</div>
                </div>
              </div>
            );
          })}
          <div className="grid grid-cols-2 md:grid-cols-12 gap-4 px-6 py-4 bg-[#0F1C40] text-[#F1EDE4]">
            <div className="col-span-2 text-sm font-medium">TOTAL</div>
            <div className="col-span-2 text-right font-mono text-sm">837,400</div>
            <div className="col-span-1 text-right font-mono text-sm">10,700</div>
            <div className="col-span-2 text-right font-mono text-sm text-[#4ECDC4] font-semibold">564</div>
            <div className="col-span-2 text-right font-mono text-sm">$38,500</div>
            <div className="col-span-1 text-right font-mono text-sm">$68</div>
            <div className="col-span-2 text-right font-mono text-sm text-[#4ECDC4]">—</div>
          </div>
        </div>
        <p className="text-xs text-white/50 mt-4 italic">Email is the highest-volume lead source · 25.6% conv. rate · zero paid spend.</p>
      </div>
    </section>
  );
}
